import { BaseApi } from '@/main/baseApi';
import { ServiceJobsDropDownListItem } from '@/main/store/@types/dropdown.d';

import { DMS_MODULE, API_NAME, EMPTY_FILE_NAME } from './constants';


class SestavyApi extends BaseApi {
	async GetRevenueDetailsReport(params: any, languageId: any, columnsSeq: any) {
		return this.downloadXlsxReport(`/${DMS_MODULE}/RevenueDetails/GetRevenueDetailsReport?${params}&ColumnSequence=${columnsSeq}&LanguageId=${languageId}`, 'RevenueDetails.xlsx');
	}

	constructor() {
		super(DMS_MODULE, API_NAME);
	}

	async exportReportbyServiceJob(dateFrom: string, dateTo: string, serviceJobs: ServiceJobsDropDownListItem[], workShopId:any) {
		return this.downloadXlsxReport(`/${DMS_MODULE}/${API_NAME}/ExportReportbyServiceJob?DateFrom=${dateFrom}&
			DateTo=${dateTo}&ServiceJobs=${serviceJobs}${workShopId}`, EMPTY_FILE_NAME);
	}
}


export const apiProvider = new SestavyApi();
